module.exports = __webpack_public_path__ + "img/3.f6c50441.png";